import React, { FC } from "react";

import BuildBanner from "../BuildBanner";
import GlobalPromoBanner from "../GlobalPromoBanner";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { PageDefaults } from "../../hooks/usePageDefaults";

interface Props {}

const Layout: FC<Props> = ({ children }) => {
  return (
    <PageDefaults>
      <BuildBanner />
      <GlobalPromoBanner />
      <Navbar />
      {children}
      <Footer />
    </PageDefaults>
  );
};

export default React.memo(Layout);
